import "../styles/footer.scss"
import {Link} from "react-router-dom";
import {useEffect, useRef, useState} from "react";
import ClipboardJS from "clipboard";

export const FooterMob = () => {
    const buttonRef = useRef(null);
    const [showMessage, setShowMessage] = useState(false);

    useEffect(() => {
        const clipboard = new ClipboardJS(buttonRef.current);

        clipboard.on('success', (e) => {
            setShowMessage(true);

            // Скрыть плашку через 3 секунды
            setTimeout(() => {
                setShowMessage(false);
            }, 3000);
        });

        clipboard.on('error', (e) => {
            console.log('Error when try to copy: ', e.text);
        });

        return () => {
            clipboard.destroy();
        };
    }, []);

    return (
        <footer id="footer" className="footer-mob">
            <div className="footer-mob__wrapper">
                
                <i className="footer-mob__angle"></i>
                
                <div className="footer-mob__content">
                    <div className="footer-mob__column">
                        <p className="footer-mob__column_header">Get in touch:</p>
                        <ul className="footer-mob__column_list">
                            <li>
                                <Link to="https://www.pinterest.co.uk/kseniainterior/"
                                      target="_blank">Pinterest
                                </Link>
                            </li>
                            <li>
                                <Link to="https://www.instagram.com/ksenia.interiors/"
                                      target="_blank">Instagram
                                </Link>
                            </li>
                            <li>
                                <Link to="https://www.facebook.com/Ksenia-Design-Ltd-112597721014951"
                                      target="_blank">Facebook
                                </Link>
                            </li>
                            <li><a href="mailto:ksenia@kseniadesign.com">Email</a></li>
                        </ul>
                        <p className="footer-mob__column_bott">PRIVACY POLICY</p>
                    </div>

                    <img className="footer-mob__img" src="./Ksenia_Design_logo.svg" height="90%" width="40%" alt="Ksenia Design"/>

                    <div className="footer-mob__column">
                        <p className="footer-mob__column_header">Our design Studio:</p>
                        <p className="footer-mob__column_address">
                            12 Grosvenor Rd. <br/>
                            East Grinstead
                            RH19 1HT
                        </p>
                        <button
                            className="footer-mob__column_bott"
                            ref={buttonRef}
                            data-clipboard-text="+447568562242"
                        >(+44)75 6856 2242
                        </button>
                        {showMessage && <div className="footer-mob__column_message opacity-animation-0_5s">Number copied!</div>}
                    </div>
                </div>
                
                <i className="footer-mob__angle"></i>

            </div>
        </footer>
    )
}